import { render, staticRenderFns } from "./default-template-v1.vue?vue&type=template&id=2c67c216&scoped=true&"
import script from "./default-template-v1.vue?vue&type=script&lang=js&"
export * from "./default-template-v1.vue?vue&type=script&lang=js&"
import style0 from "./default-template-v1.vue?vue&type=style&index=0&id=2c67c216&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c67c216",
  null
  
)

export default component.exports